<div class="auth-layout">
  <img src="/public/logos/logo-blue-text.gif" alt="Deeploy logo" />

  <div class="auth-layout__container">
    <router-outlet></router-outlet>
  </div>
</div>
